module.exports = __webpack_public_path__ + "static/media/loading-animation.cfc0905d.gif";